import { clsx } from 'clsx';
import type { OverviewStateId } from '../api/overviewApi';
import styles from './DemoStateSwitcher.module.css';

interface DemoStateSwitcherProps {
  active: OverviewStateId | undefined;
  onChange: (id: OverviewStateId | undefined) => void;
}

const STATES: { id: OverviewStateId; label: string; desc: string }[] = [
  { id: 'zero', label: 'Zero', desc: 'Nothing connected' },
  { id: 'strategy', label: 'Strategy Only', desc: 'Strategy created, no ads or SEO' },
  { id: 'ads_only', label: 'Ads Connected', desc: 'Ads live — strategy may or may not exist' },
  { id: 'seo_only', label: 'SEO Connected', desc: 'GBP/GSC live, no ads' },
  { id: 'active_30d', label: 'Active <30d', desc: 'All live, campaigns <30 days old' },
  { id: 'ongoing', label: 'Ongoing >30d', desc: 'Full steady state' },
];

export function DemoStateSwitcher({ active, onChange }: DemoStateSwitcherProps) {
  return (
    <div className={styles.root}>
      <span className={styles.label}>DEMO:</span>
      <button
        type="button"
        onClick={() => onChange(undefined)}
        className={clsx(styles.pill, active === undefined && styles.pillActive)}
        title="Live (real data)"
      >
        Live
      </button>
      {STATES.map((s) => (
        <button
          key={s.id}
          type="button"
          onClick={() => onChange(s.id)}
          className={clsx(styles.pill, active === s.id && styles.pillActive)}
          title={s.desc}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
